// src/type-checks.ts
function isObject(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
function isNil(value) {
  return value == null;
}
function isNotNil(value) {
  return value !== null && value !== void 0;
}
function isNull(value) {
  return value === null;
}
function isUndefined(value) {
  return value === void 0;
}

export {
  isObject,
  isNil,
  isNotNil,
  isNull,
  isUndefined
};
